import React, {Fragment} from 'react'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'

// Material-UI Icon

// Custom Component
import UserGroupTransferList from './UserGroupTransferList'

// Custom Style
import {userGroupFormStyle} from '../../styles/jss/components/userGroup/userGroupFormStyle'


const useStyles = makeStyles(theme => userGroupFormStyle(theme))

const UserGroupForm = props => {
	const classes = useStyles()
	const {userList, userGroupValue, setUserGroupValue, validate, validationErrors} = props


	const handleChange = event => {
		const {name, value} = event.target
		let tempRecord = {...userGroupValue}

		tempRecord[name] = value
		setUserGroupValue(tempRecord)

		if (validationErrors[name]) {
			validate(tempRecord)
		}
	}


	return (
		// console.log("User Group Value | Variable: userGroupValue (UserGroupForm.js)"),
		// console.log(userGroupValue),
		
		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<Paper className={classes.groupFieldPaper}>
				<div className={classes.groupFieldText}>
					<TextField
						id={"group_name"}
						name={"group_name"}
						label={"Group Name"}
						required
						type="text"
						fullWidth={true}
						size="small"
						variant="outlined"
						value={userGroupValue !== null ? userGroupValue.group_name : ""}
						onChange={handleChange}
						error={validationErrors.group_name && validationErrors.group_name !== "" ? true : false}
						helperText={validationErrors.group_name}
					/>

					<TextField
						id={"group_description"}
						name={"group_description"}
						label={"Group Description"}
						required
						type="text"
						fullWidth={true}
						size="small"
						variant="outlined"
						value={userGroupValue !== null ? userGroupValue.group_description : ""}
						onChange={handleChange}
						error={validationErrors.group_description && validationErrors.group_description !== "" ? true : false}
						helperText={validationErrors.group_description}
					/>
				</div>
			</Paper>

			<UserGroupTransferList 
				userList={userList}
				userGroupValue={userGroupValue}
				setUserGroupValue={setUserGroupValue}
			/>
		</Fragment>
	)
}


export default UserGroupForm